import { EPaymentMode, IAvailablePairDto, IAvailablePairDtoWithModeType } from './getValidPairsAndCurrencies'

enum EFiatCurrency {
    USD = 'USD',
    EUR = 'EUR'
}

const parseCurrencyPair = (pair: string, fiatCurrency: EFiatCurrency): {fromCurrency: string, toCurrency: EFiatCurrency} | null => (
    { fromCurrency: pair.replace(fiatCurrency, ''), toCurrency: fiatCurrency }
)

const findAndParseCurrencyPair  = (pair: string): { fromCurrency: string, toCurrency: EFiatCurrency } | null => {
    const fiatCurrency = Object.values(EFiatCurrency).find(currency => pair.slice(0, currency.length).includes(currency))

    if (fiatCurrency) {
        return parseCurrencyPair(pair, fiatCurrency)
    } else {
        return null
    }
}

const parseValidatedPairFormQuery = (
    pairName: string,
    allAvailablePairs: IAvailablePairDto[] = [],
): IAvailablePairDtoWithModeType | null => {
    if (!pairName) return null

    // TODO: convert to specific n.exchange pair

    const validatedPairForBuyMode = allAvailablePairs.find(validPair => validPair.name === pairName)

    if(validatedPairForBuyMode) {
        return { ...validatedPairForBuyMode, paymentMode: EPaymentMode.BUY }
    } else {
        const parsedCurrencyPair =  findAndParseCurrencyPair(pairName)

        if (!parsedCurrencyPair) return null

        const { fromCurrency, toCurrency } = parsedCurrencyPair
        const pairNameReversed = `${fromCurrency}${toCurrency}`
        const validatedPairForSellMode = allAvailablePairs.find(validPair => validPair.name === pairNameReversed)
        if(validatedPairForSellMode) {
            return { ...validatedPairForSellMode, paymentMode: EPaymentMode.SELL }
        } else {
            return null
        }
    }
}

export { parseValidatedPairFormQuery }
